exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img.store-logo[data-v-41ec8655]{height:41px}@media only screen and (min-width: 1025px){img.store-logo[data-v-41ec8655]{max-height:60px;padding-right:30px}}\n", ""]);

// exports
